import { render } from "./BillngTable.vue?vue&type=template&id=9cc54606&scoped=true"
import script from "./BillngTable.vue?vue&type=script&lang=js"
export * from "./BillngTable.vue?vue&type=script&lang=js"

import "./BillngTable.vue?vue&type=style&index=0&id=9cc54606&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc54606"]])

export default __exports__